import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

import './localize'
import { components } from 'aws-amplify-vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import aws_exports from './aws-exports'
import vuetify from './plugins/vuetify'

Amplify.configure(aws_exports)
Vue.use(AmplifyPlugin, AmplifyModules)

Vue.config.productionTip = false
Vue.use(VueAxios, axios)

new Vue({
  router,
  store,

  comments: {
    App,
    ...components
  },

  render: h => h(App),
  vuetify,

  //最初の1回だけ、まだログイン状態だったらstateにユーザー情報を保存する処理を走らせる
  created(){
    this.$store.dispatch('getUser')
  }
}).$mount('#app')